import { useEffect, useRef, useState } from "react";
import {
  createPeerVideoConnection,
  deletePeerConnection,
  getPeerConnection,
} from "./webrtc_video_connection";
import { RobotAgent, RobotConnectionState } from "../../panels/worldpanelparts/robot/RobotAgent";
import { AgentEvents } from "../../panels/worldpanelparts/agents/BaseAgent";

export function LiveCamera({ agent }: { agent: RobotAgent | null }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [lastActorId, setLastActorId] = useState<string>('');
  // Fetch robots once on mount
  useEffect(() => {
    if (!agent && lastActorId && getPeerConnection(lastActorId)) {
      deletePeerConnection(lastActorId);
      setLastActorId('');
    };
    if (!videoRef.current) return;
    if (!agent) {
      return;
    }
    const feed = getPeerConnection(agent.robotId);
    if (feed) {
      try {
        deletePeerConnection(agent.robotId);
      } catch (error) {
        console.error("Error closing peer connection", error);
      }
    }
    const listener = async (dgram: Partial<RobotAgent>) => {
      if (!dgram) {
        return;
      }
      if (dgram.connectionState) {
        if (dgram.connectionState === RobotConnectionState.Connected) {
          // setTimeout(async () => {
          const feed = await createPeerVideoConnection(agent.robotVisual.robot);
          videoRef.current!.srcObject = feed.mediaStream;
          // }, 5000);
          setLastActorId(agent.robotId);
        } else if (dgram.connectionState === RobotConnectionState.Disconnected) {
          if (getPeerConnection(agent.robotId)) {
            deletePeerConnection(agent.robotId);
            setLastActorId('');
          }
        }
      }
    };
    agent.on(AgentEvents.StateChange, listener);
    listener(agent);
    return () => {
      agent.off(AgentEvents.StateChange, listener);
      deletePeerConnection(agent.robotId);
    };
  }, [agent]);


  return (
    <video
      ref={videoRef}
      style={{
        background: "black",
        border: "1px solid green",
        width: "100%",
        height: "100%",
        display: "block",
        margin: 0,
        padding: 0,
      }}
      muted={true}
      autoPlay={true}
      playsInline={true}
    ></video>

    // <ObjectDetectionOverlay
    //   detections={detections}
    //   scale={isMaximized ? 1.5 : 640 / 352}
    // />
  );
}
